import React, { useEffect } from 'react'
import { Flex, Tooltip, Tabs, Popover, Avatar, Tag, Dropdown } from 'antd'
import type { MenuProps } from 'antd'
import { GlobalOutlined, MenuUnfoldOutlined, KeyOutlined } from '@ant-design/icons'
import { Outlet, useNavigate } from 'react-router-dom'
import useStationListStore from '@/stores/stationList'
import useMessage from '@/hooks/useMessage'
import useGlobalConfigStore from '@/stores/globalConfig'
import formatDate from '@/utils/formatDate'
import { useTranslation } from 'react-i18next'
import usePersistDataStore from '@/stores/persistData'
import appConfig from '@/config'

const UserInfoCard: React.FC = () => {
  const { t } = useTranslation()
  const userInfo = usePersistDataStore(state => state.userInfo)
  const logOut = usePersistDataStore(state => state.logOut)
  const navigate = useNavigate()

  const logout = () => {
    logOut()
    navigate('/login')
  }

  return (
    <div className='UserInfoCard'>
      <div className='UserInfoCard-header'>
        <Flex gap={10} align='center'>
          <Avatar
            src={appConfig.staticFile + userInfo.avatar}
            className='avatar'
            style={{ backgroundColor: 'var(--main-color)' }}>
            U
          </Avatar>
          <Flex vertical gap={0}>
            <span className='UserInfoCard-header-username'>
              <Flex gap={10}>
                {userInfo.name}
                {/* <Tag color='success'>magenta</Tag> */}
              </Flex>
            </span>
            <span>{userInfo.email}</span>
          </Flex>
        </Flex>
      </div>
      <Flex vertical className='UserInfoCard-content'>
        <div className='UserInfoCard-item'>
          <Flex gap={5}>
            <KeyOutlined />
            {t('user.changePassword')}
          </Flex>
        </div>
        <div className='UserInfoCard-item' onClick={logout}>
          <Flex gap={5}>
            <MenuUnfoldOutlined />
            {t('user.logOut')}
          </Flex>
        </div>
      </Flex>
    </div>
  )
}

const MainTab: React.FC = () => {
  const { t } = useTranslation()
  const lang = usePersistDataStore(state => state.lang)
  const setLang = usePersistDataStore(state => state.setLang)
  const userInfo = usePersistDataStore(state => state.userInfo)
  // const navigate = useNavigate()
  // const { pathname } = useLocation()
  // const stationListStore = useStationListStore()
  const stationInit = useStationListStore(state => state.stationInit)
  const updateTime = useGlobalConfigStore(state => state.updateTime)
  const { message } = useMessage()

  useEffect(() => {
    if (userInfo.token && userInfo.token !== '') {
      stationInit().catch(e => {
        console.log(e)
        message.error(e.message || e.msg || e)
      })
    }
  }, [userInfo.token])

  const tabItems = [
    { key: '/overview', label: t('menu.overview') },
    { key: '/sitelist', label: t('menu.list') },
  ]

  const langItems: MenuProps['items'] = [
    { key: 'en_US', label: 'English' },
    { key: 'zh_CN', label: '简体中文' },
  ]

  const selectLang = ({ key }: any) => {
    setLang(key)
  }

  // useEffect(() => {
  //   console.log(stationListStore)
  // }, [stationListStore])

  return (
    <div className='app-content'>
      <div className='app-header'>
        <div className='app-header-left'>
          <img className='logo' src='/assets/web/logo.svg' />
          <div className='su'></div>
          <Flex vertical gap={2}>
            <Flex gap={15} align='center'>
              <Flex align='center' gap={6}>
                <Tooltip title='Data Center Connected Successfully'>
                  <i className='yuan success' style={{ width: 8, height: 8 }}></i>
                </Tooltip>
                <div className='data-center'>
                  <Flex align='end'>{t('common.adc')}</Flex>
                </div>
              </Flex>
              <img className='ref' style={{ width: 14, height: 14 }} src='/assets/web/ref.svg' />
            </Flex>
            <div className='app-header-left-bottom'>
              {t('common.updateTime')}:&nbsp;{formatDate(updateTime)}
            </div>
          </Flex>
        </div>
        <div className='app-header-right'>
          <div className='app-header-main'>
            <Flex align='center' gap={25}>
              {/* <Tabs style={{width:"300px"}}
                activeKey={pathname}
                size='large'
                items={tabItems}
                onChange={(activeKey) => navigate(activeKey as string)}
              /> */}
              <div className='su'></div>
              <Dropdown menu={{ items: langItems, selectable: true, selectedKeys: [lang], onSelect: selectLang }}>
                <a
                  onClick={e => e.preventDefault()}
                  style={{ width: '100px', display: 'flex', justifyContent: 'space-between' }}>
                  <GlobalOutlined />
                  <span className='f14'>
                    {lang === 'en_US' ? 'English' : lang === 'zh_CN' ? '简体中文' : 'Unknown Langauge'}
                  </span>
                  <img src='/assets/web/next1.svg' />
                </a>
              </Dropdown>
              <Popover placement='bottom' content={<UserInfoCard />}>
                <Avatar
                  src={appConfig.staticFile + userInfo.avatar}
                  className='avatar'
                  style={{ backgroundColor: 'var(--main-color)' }}>
                  U
                </Avatar>
              </Popover>
            </Flex>
          </div>
        </div>
      </div>
      <div style={{ height: 'calc(100% - 74px)', padding: '15px' }}>
        <Outlet />
      </div>
    </div>
  )
}

export default MainTab
